import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const StaroflifeIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM11 7.5l.5-.5h1l.5.5v2.768l2.397-1.384.683.183.5.866-.183.683L14 12l2.397 1.384.183.683-.5.866-.683.183L13 13.732V16.5l-.5.5h-1l-.5-.5v-2.768l-2.397 1.384-.683-.183-.5-.866.183-.683L10 12l-2.397-1.384-.183-.683.5-.866.683-.183L11 10.268V7.5Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m11 7.5.5-.5h1l.5.5v2.768l2.397-1.384.683.183.5.866-.183.683L14 12l2.397 1.384.183.683-.5.866-.683.183L13 13.732V16.5l-.5.5h-1l-.5-.5v-2.768l-2.397 1.384-.683-.183-.5-.866.183-.683L10 12l-2.397-1.384-.183-.683.5-.866.683-.183L11 10.268V7.5Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-1.8 0a7.2 7.2 0 1 1-14.4 0 7.2 7.2 0 0 1 14.4 0Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `StaroflifeIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { StaroflifeIcon };
//# sourceMappingURL=StaroflifeIcon.mjs.map
